// src/lib/emojiInput.js

/**
 * Detect if the environment can show a native emoji keyboard.
 * Basic UA sniff: returns true for modern iOS/Android browsers.
 */
export function supportsNativeEmojiInput() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = /android/.test(ua);
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isModern =
    ua.includes("chrome") ||
    ua.includes("safari") ||
    ua.includes("edge") ||
    ua.includes("firefox");
  return (isAndroid || isIOS) && isModern;
}

/**
 * Light haptic feedback for selections when supported.
 */
export function triggerHapticFeedback(duration = 50) {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) {
      navigator.vibrate(duration);
    }
  } catch {}
}
